import Home from "./pages/Home.svelte";
import Blog from "./pages/Blog.svelte";
import Article from "./pages/Article.svelte";
import Private from "./pages/Private.svelte";
import Login from "./pages/Login.svelte";
import Error from "./pages/Error.svelte";
import About from "./pages/About.svelte";
import Listen from "./pages/Listen.svelte";



export default [
  {
    path: "/",
    component: Home
  },
  {
    path: "/listen",
    component: Listen
  },
  {
    path: "/about-us",
    component: About
  },
  // {
  //   path: "/donate",
  //   component: Donate
  // },
  // {
  //   path: "/adopt",
  //   component: Adoption
  // },
  // {
  //   path: "/volunteer",
  //   component: Volunteer
  // },
  // {
  //   path: "/blog/:id",
  //   component: Article
  // },
  // {
  //   path: "/private",
  //   component: Private,
  //   auth: true
  // },
  // {
  //   path: "/login",
  //   component: Login
  // },
  {
    path: "*",
    component: Error
  }
];
